
document.addEventListener("DOMContentLoaded", () => {
    (function () {
      const body = document.getElementsByTagName("body")[0];
      const mobileNavToggle = document.querySelector(".mobile-nav-toggle");
      const nav = document.getElementById("site-navigation");
      const dropdownItems = document.querySelectorAll(".has-dropdown");

      const hideMobile = window.matchMedia("(min-width: 768px)");

      const viewportClasses = ()=>{
        if (hideMobile.matches) {
          body.classList.remove("mobile-layout");
          nav.classList.remove("active");
          mobileNavToggle.classList.remove("active");
          mobileNavToggle.setAttribute("aria-expanded", "false");
          dropdownItems.forEach((item) => item.classList.remove("active"));
        } else {
          body.classList.add("mobile-layout");
        }
      }
      viewportClasses();
      hideMobile.addEventListener("change", (e) => {
        viewportClasses();
      });

      mobileNavToggle.addEventListener("click", () => {
        nav.classList.toggle("active");
        mobileNavToggle.classList.toggle("active");

        if (mobileNavToggle.classList.contains("active")) {
          mobileNavToggle.setAttribute("aria-expanded", "true");
          mainMasthead.classList.add("mobile-menu");
        } else {
          mobileNavToggle.setAttribute("aria-expanded", "false");
          mainMasthead.classList.remove("mobile-menu");
        }
      });

      dropdownItems.forEach((item) => {
        const link = item.querySelector(".nav-link");
        link.addEventListener("click", (e) => {
          if (window.innerWidth < 768) {
            e.preventDefault();
            item.classList.toggle("active");
          }
        });
      });

    })();
});
